export const Spinner = () => (
	<div className="flex h-1/2 items-center justify-center">
		<div className="h-8 w-8 animate-spin rounded-full border-2 border-[rgba(0,0,0,0.1)] border-t-boulder2" />
	</div>
)
